/**
 * Coerces an API numeric into a real number, or null.
 *
 * JSON from Postgres is not uniformly numeric: `numeric` and `bigint`
 * columns arrive as strings so precision survives the trip, and an
 * aggregate can quietly change a column's type (avg() over an integer
 * returns numeric). A chart that assumes it received a number will throw
 * the moment it calls a number method on one of those strings.
 */
export function toChartNumber(value: unknown): number | null {
  if (value === null || value === undefined) return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value === "string") {
    // Number("") and Number(" ") are both 0. Treating an empty value as zero
    // would draw a flat line that reads as a real measurement -- the same
    // confident-zero problem as an unwired sensor. Absent means absent.
    if (value.trim() === "") return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}
